"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _components = require("./components");

var _useUniqueId = _interopRequireDefault(require("../../utils/useUniqueId"));

var _utils = require("./utils");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  } else {
    var newObj = {};

    if (obj != null) {
      for (var key in obj) {
        if (Object.prototype.hasOwnProperty.call(obj, key)) {
          var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {};

          if (desc.get || desc.set) {
            Object.defineProperty(newObj, key, desc);
          } else {
            newObj[key] = obj[key];
          }
        }
      }
    }

    newObj.default = obj;
    return newObj;
  }
}

function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest();
}

function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance");
}

function _iterableToArrayLimit(arr, i) {
  var _arr = [];
  var _n = true;
  var _d = false;
  var _e = undefined;

  try {
    for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);

      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }

  return _arr;
}

function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}

var ResponsiveModalWrapper = function ResponsiveModalWrapper(_ref) {
  var children = _ref.children,
      breakpoint = _ref.breakpoint,
      _ref$hasFooter = _ref.hasFooter,
      hasFooter = _ref$hasFooter === void 0 ? true : _ref$hasFooter,
      id = _ref.id,
      _ref$size = _ref.size,
      size = _ref$size === void 0 ? 'normal' : _ref$size,
      onClose = _ref.onClose,
      _ref$zIndex = _ref.zIndex,
      zIndex = _ref$zIndex === void 0 ? 100 : _ref$zIndex,
      observedElementRef = _ref.observedElementRef; // Any click within the overlay should stay within the overlay. This click event should close
  // the modal, but not bubble up to any parent elements.

  var handleOverlayClick = (0, _react.useCallback)(function (event) {
    event.preventDefault();
    event.stopPropagation();
    onClose && onClose(event);
  }, [onClose]); // Any click within the body should stay within the body. This prevents the click event from
  // bubbling up and firing the onClose handler via the Overlay's onClick.

  var handleBodyClick = (0, _react.useCallback)(function (event) {
    event.preventDefault();
    event.stopPropagation();
  }, []);

  var _useElement = (0, _utils.useElement)(),
      _useElement2 = _slicedToArray(_useElement, 2),
      container = _useElement2[0],
      containerRef = _useElement2[1];

  (0, _utils.useKeepFocusWithin)(container);
  var uuid = (0, _useUniqueId.default)(id, 'modal-');
  var modalHeaderId = "modal-header-".concat(uuid);
  var modalContentId = "modal-content-".concat(uuid);
  return _react.default.createElement(_components.Overlay, {
    onClick: handleOverlayClick,
    ref: observedElementRef,
    zIndex: zIndex
  }, _react.default.createElement(_components.Body, {
    hasFooter: hasFooter,
    widthSize: size,
    "aria-describedby": modalContentId,
    "aria-labelledby": modalHeaderId,
    "aria-modal": "true",
    size: breakpoint,
    id: uuid,
    onClick: handleBodyClick,
    ref: containerRef,
    role: "dialog"
  }, children));
};

var _default = ResponsiveModalWrapper;
exports.default = _default;